import { currencyUtils } from '~/utils/currency.utils';
export const roundYearlyAmount = (amount)=>Math.round(amount / 10) * 10;
export const formatSignedDollars = (sign, dollars)=>"".concat(sign).concat(currencyUtils.formatDollarAmount(dollars));
export const formatYearlyAmount = (amount)=>currencyUtils.formatDollarAmount(roundYearlyAmount(amount));
